// // components/ImportUserTemplate.jsx
// import React, { useState, useEffect, useRef } from 'react';
// import { useDispatch } from 'react-redux';
// import { X, Smartphone, User, Fingerprint, Loader2, AlertCircle, Wifi, CheckCircle, XCircle } from 'lucide-react';
// import {Get_Managers_User} from '../../../services/oprations/Users'

// const ImportUserTemplate = ({ 
//   isOpen, 
//   onClose, 
//   users, 
//   devices, 
//   onSubmit, 
//   isEnrolling,
//   errors,
//   preselectedUser = null,
//   socket = null
// }) => {
//   const dispatch = useDispatch()
//   const [selectedUserId, setSelectedUserId] = useState('');
//   const [selectedDeviceId, setSelectedDeviceId] = useState('');
//   const [selectedTemplateId, setSelectedTemplateId] = useState('');
//   const [localErrors, setLocalErrors] = useState({});
//   const [selectedUserTemplates, setSelectedUserTemplates] = useState([]);
  
//   // Socket communication states
//   const [socketStatus, setSocketStatus] = useState(null);
//   const [socketMessage, setSocketMessage] = useState('');
//   const [isProcessing, setIsProcessing] = useState(false);
//   const [receivedSuccess, setReceivedSuccess] = useState(false);
//   const [hasSubmitted, setHasSubmitted] = useState(false);
  
//   // Use ref to track if component is mounted
//   const isMounted = useRef(true);
//   const timeoutRef = useRef(null);

//   // Set isMounted on mount/unmount
//   useEffect(() => {
//     isMounted.current = true;
//     return () => {
//       isMounted.current = false;
//       if (timeoutRef.current) {
//         clearTimeout(timeoutRef.current);
//       }
//     };
//   }, []);

//   // Reset form when modal opens
//   useEffect(() => {
//     if (isOpen) {
//       if (preselectedUser) {
//         setSelectedUserId(preselectedUser._id);
//       } else {
//         setSelectedUserId('');
//       }
//       setSelectedDeviceId('');
//       setSelectedTemplateId('');
//       setLocalErrors({});
//       setSelectedUserTemplates([]);
//       setSocketStatus(null);
//       setSocketMessage('');
//       setIsProcessing(false);
//       setReceivedSuccess(false);
//       setHasSubmitted(false);
//     }
//   }, [isOpen, preselectedUser]);

//   // Socket event listeners - SAFE VERSION with error handling
//   useEffect(() => {
//     if (!socket || !isOpen || !socket.on) return;

//     // Safe handler that catches any cross-origin errors
//     const handleImportProcess = (data) => {
//       // Check if component is still mounted
//       if (!isMounted.current) return;
      
//       try {
//         // Safely access data properties
//         const message = data && typeof data === 'object' ? data.message : null;
//         const errorDetails = data && typeof data === 'object' ? data.errorDetails : null;
        
//         console.log("Socket IMPORT_PROCESS received:", message);
        
//         // Update state safely
//         if (message === 'SUCCESS') {
//           setSocketStatus('success');
//           setSocketMessage('User successfully enrolled to device!');
//           setIsProcessing(false);
//           setReceivedSuccess(true);
//           dispatch(Get_Managers_User())
          
//           // Close modal after delay
//           timeoutRef.current = setTimeout(() => {
//             if (isMounted.current) {
//               onClose();
//             }
//           }, 2000);
//         } 
//         else if (message === 'FAILED' || message === 'error') {
//           setSocketStatus('error');
//           setSocketMessage(errorDetails || 'Enrollment failed. Please try again.');
//           setIsProcessing(false);
//           setHasSubmitted(false);
//         }
//         else if (message) {
//           setSocketMessage(message);
//           if (typeof message === 'string' && 
//               (message.includes('processing') || message.includes('started'))) {
//             setSocketStatus('processing');
//             setIsProcessing(true);
//           }
//         }
//       } catch (err) {
//         // Catch and log any errors without crashing
//         console.error('Error handling socket message:', err);
//         if (isMounted.current) {
//           setSocketStatus('error');
//           setSocketMessage('An error occurred. Please try again.');
//           setIsProcessing(false);
//           setHasSubmitted(false);
//         }
//       }
//     };

//     // Attach listener safely
//     try {
//       socket.on('IMPORT_PROCESS', handleImportProcess);
//     } catch (err) {
//       console.error('Failed to attach socket listener:', err);
//     }

//     // Cleanup
//     return () => {
//       try {
//         if (socket && socket.off) {
//           socket.off('IMPORT_PROCESS', handleImportProcess);
//         }
//       } catch (err) {
//         console.error('Failed to remove socket listener:', err);
//       }
//     };
//   }, [socket, isOpen, onClose]);

//   // Load user templates when user is selected
//   useEffect(() => {
//     if (selectedUserId && users && users.length) {
//       try {
//         const selectedUser = users.find(u => u._id === selectedUserId);
//         const templates = selectedUser?.Templates || [];
//         setSelectedUserTemplates(templates);
        
//         if (templates.length > 0 && !selectedTemplateId && isMounted.current) {
//           setSelectedTemplateId(templates[0]._id);
//         }
//       } catch (err) {
//         console.error('Error loading user templates:', err);
//         setSelectedUserTemplates([]);
//       }
//     } else {
//       setSelectedUserTemplates([]);
//     }
//   }, [selectedUserId, users]);

//   const validateForm = () => {
//     const newErrors = {};
//     if (!selectedUserId) newErrors.user = 'Please select a user';
//     if (!selectedDeviceId) newErrors.device = 'Please select a device';
//     if (!selectedTemplateId?.trim()) newErrors.template = 'Please select a fingerprint template';
    
//     setLocalErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = (e) => {
//     // Prevent default and stop propagation to avoid cross-origin issues
//     if (e) {
//       e.preventDefault();
//       e.stopPropagation();
//     }
    
//     // Prevent double submission
//     if (hasSubmitted || isProcessing || !isMounted.current) {
//       console.log("Submission already in progress or component unmounted, ignoring...");
//       return;
//     }
    
//     if (validateForm()) {
//       try {
//         const selectedUser = users.find(u => u._id === selectedUserId);
//         const selectedDevice = devices.find(d => d._id === selectedDeviceId);
//         const selectedTemplate = selectedUserTemplates.find(t => t._id === selectedTemplateId);
        
//         setSocketStatus('processing');
//         setSocketMessage('Sending enrollment request...');
//         setReceivedSuccess(false);
//         setIsProcessing(true);
//         setHasSubmitted(true);
        
//         // Call onSubmit with safe data
//         onSubmit({
//           userId: selectedUserId,
//           deviceId: selectedDeviceId,
//           templateId: selectedTemplateId,
//           templateType: selectedTemplate?.Type || '',
//           userEmail: selectedUser?.user_email || '',
//           userName: selectedUser?.user_name || '',
//           deviceName: selectedDevice?.device_name || '',
//         });
//       } catch (err) {
//         console.error('Error in handleSubmit:', err);
//         setSocketStatus('error');
//         setSocketMessage('Failed to submit enrollment request');
//         setIsProcessing(false);
//         setHasSubmitted(false);
//       }
//     }
//   };

//   const getStatusIcon = () => {
//     try {
//       switch(socketStatus) {
//         case 'success':
//           return <CheckCircle className="w-5 h-5 text-green-400" />;
//         case 'error':
//           return <XCircle className="w-5 h-5 text-red-400" />;
//         case 'processing':
//           return <Loader2 className="w-5 h-5 text-blue-400 animate-spin" />;
//         default:
//           return <Wifi className="w-5 h-5 text-blue-400" />;
//       }
//     } catch {
//       return <Wifi className="w-5 h-5 text-blue-400" />;
//     }
//   };

//   const getStatusColor = () => {
//     switch(socketStatus) {
//       case 'success':
//         return 'border-green-500/50 bg-green-900/20';
//       case 'error':
//         return 'border-red-500/50 bg-red-900/20';
//       case 'processing':
//         return 'border-blue-500/50 bg-blue-900/20';
//       default:
//         return 'border-blue-700/50 bg-richblue-800';
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
//       <div className="relative w-full max-w-md border shadow-xl bg-richblue-800 rounded-xl border-blue-700/50">
//         {/* Header */}
//         <div className="flex items-center justify-between p-4 border-b border-blue-700/50">
//           <div className="flex items-center gap-2">
//             <div className="p-1.5 rounded-lg bg-blue-500/20">
//               <Fingerprint className="w-4 h-4 text-blue-400" />
//             </div>
//             <h2 className="text-lg font-semibold text-white">
//               Enroll {preselectedUser ? preselectedUser.user_name : 'User'} to Device
//             </h2>
//           </div>
//           <button
//             onClick={() => {
//               if (timeoutRef.current) clearTimeout(timeoutRef.current);
//               onClose();
//             }}
//             className="p-1 transition-colors rounded-lg hover:bg-richblue-700"
//             disabled={isEnrolling || (isProcessing && !receivedSuccess)}
//           >
//             <X className="w-5 h-5 text-gray-400" />
//           </button>
//         </div>

//         {/* Socket Status Display */}
//         {socket && socketStatus && (
//           <div className={`mx-4 mt-4 p-3 rounded-lg border ${getStatusColor()} transition-all duration-300`}>
//             <div className="flex items-center gap-3">
//               {getStatusIcon()}
//               <div className="flex-1">
//                 <p className="text-sm font-medium text-white">
//                   {socketStatus === 'processing' ? 'Processing Enrollment' : 
//                    socketStatus === 'success' ? 'Enrollment Successful' :
//                    socketStatus === 'error' ? 'Enrollment Failed' :
//                    'Status'}
//                 </p>
//                 {socketMessage && (
//                   <p className="mt-1 text-xs text-gray-300">{socketMessage}</p>
//                 )}
//                 {socketStatus === 'processing' && (
//                   <div className="mt-2">
//                     <div className="w-full bg-richblue-700 rounded-full h-1.5 overflow-hidden">
//                       <div 
//                         className="bg-blue-500 h-1.5 rounded-full animate-pulse"
//                         style={{ width: '100%' }}
//                       />
//                     </div>
//                     <p className="mt-1 text-xs text-gray-400">Waiting for device response...</p>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         )}

//         <form onSubmit={handleSubmit} className="p-4 space-y-4">
//           {/* Rest of your form JSX remains the same */}
//           {/* User Selection */}
//           <div>
//             <label className="block mb-2 text-sm font-medium text-gray-300">
//               Select User <span className="text-red-400">*</span>
//             </label>
//             <div className="relative">
//               <User className="absolute w-4 h-4 text-gray-400 -translate-y-1/2 left-3 top-1/2" />
//               <select
//                 value={selectedUserId}
//                 onChange={(e) => setSelectedUserId(e.target.value)}
//                 className={`w-full pl-9 pr-3 py-2 bg-richblue-900 border rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 ${
//                   localErrors.user ? 'border-red-500' : 'border-blue-700/50'
//                 } ${preselectedUser ? 'opacity-60 cursor-not-allowed' : ''}`}
//                 disabled={isEnrolling || isProcessing || !!preselectedUser}
//               >
//                 <option value="">Select a user...</option>
//                 {users.map((user) => (
//                   <option key={user._id} value={user._id}>
//                     {user.user_name} ({user.user_email || 'No email'}) - {user.Templates?.length || 0} template(s)
//                   </option>
//                 ))}
//               </select>
//             </div>
//             {localErrors.user && (
//               <p className="mt-1 text-xs text-red-400">{localErrors.user}</p>
//             )}
//           </div>

//           {/* Device Selection */}
//           <div>
//             <label className="block mb-2 text-sm font-medium text-gray-300">
//               Select Device <span className="text-red-400">*</span>
//             </label>
//             <div className="relative">
//               <Smartphone className="absolute w-4 h-4 text-gray-400 -translate-y-1/2 left-3 top-1/2" />
//               <select
//                 value={selectedDeviceId}
//                 onChange={(e) => setSelectedDeviceId(e.target.value)}
//                 className={`w-full pl-9 pr-3 py-2 bg-richblue-900 border rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 ${
//                   localErrors.device ? 'border-red-500' : 'border-blue-700/50'
//                 }`}
//                 disabled={isEnrolling || isProcessing}
//               >
//                 <option value="">Select a device...</option>
//                 {devices.map((device) => (
//                   <option key={device._id} value={device._id}>
//                     {device.device_name} ({device.status || 'Unknown'})
//                   </option>
//                 ))}
//               </select>
//             </div>
//             {localErrors.device && (
//               <p className="mt-1 text-xs text-red-400">{localErrors.device}</p>
//             )}
//           </div>

//           {/* Template Selection */}
//           <div>
//             <label className="block mb-2 text-sm font-medium text-gray-300">
//               Select Fingerprint Template <span className="text-red-400">*</span>
//             </label>
            
//             {selectedUserTemplates.length > 0 ? (
//               <div className="p-2 mb-2 border rounded-lg bg-blue-900/20 border-blue-700/50">
//                 <div className="flex items-center gap-2 mb-2">
//                   <AlertCircle className="w-3 h-3 text-blue-400" />
//                   <span className="text-xs text-blue-300">Available templates:</span>
//                 </div>
//                 <div className="space-y-2">
//                   {selectedUserTemplates.map((template) => (
//                     <label 
//                       key={template._id}
//                       className={`flex items-center gap-2 p-2 rounded-lg cursor-pointer transition-colors ${
//                         selectedTemplateId === template._id 
//                           ? 'bg-blue-500/30 border border-blue-400' 
//                           : 'bg-richblue-900/50 border border-blue-700/30 hover:bg-blue-500/10'
//                       }`}
//                     >
//                       <input
//                         type="radio"
//                         name="template"
//                         value={template._id}
//                         checked={selectedTemplateId === template._id}
//                         onChange={() => setSelectedTemplateId(template._id)}
//                         className="w-4 h-4 text-blue-500"
//                         disabled={isProcessing}
//                       />
//                       <div className="flex-1">
//                         <div className="flex items-center justify-between">
//                           <span className="text-sm font-medium text-white">{template.Type}</span>
//                           <span className="font-mono text-xs text-gray-400">
//                             ID: {template._id?.slice(-6)}
//                           </span>
//                         </div>
//                       </div>
//                       <Fingerprint className="w-4 h-4 text-blue-400" />
//                     </label>
//                   ))}
//                 </div>
//               </div>
//             ) : (
//               selectedUserId && (
//                 <div className="p-3 border rounded-lg bg-yellow-900/20 border-yellow-700/50">
//                   <p className="text-xs text-yellow-300">
//                     ⚠️ This user has no fingerprint templates registered.
//                   </p>
//                 </div>
//               )
//             )}
            
//             {localErrors.template && (
//               <p className="mt-1 text-xs text-red-400">{localErrors.template}</p>
//             )}
//           </div>

//           {/* Buttons */}
//           <div className="flex gap-3 pt-2">
//             <button
//               type="button"
//               onClick={() => {
//                 if (timeoutRef.current) clearTimeout(timeoutRef.current);
//                 onClose();
//               }}
//               className="flex-1 px-4 py-2 text-sm font-medium text-gray-300 transition-colors rounded-lg bg-richblue-700 hover:bg-richblue-600"
//               disabled={isEnrolling || (isProcessing && !receivedSuccess)}
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={isEnrolling || isProcessing || (selectedUserId && selectedUserTemplates.length === 0) || hasSubmitted}
//               className="flex items-center justify-center flex-1 gap-2 px-4 py-2 text-sm font-semibold text-white transition-colors bg-blue-600 rounded-lg hover:bg-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               {isEnrolling || isProcessing ? (
//                 <>
//                   <Loader2 className="w-4 h-4 animate-spin" />
//                   {socketStatus === 'processing' ? 'Processing...' : 'Enrolling...'}
//                 </>
//               ) : (
//                 <>
//                   <Fingerprint className="w-4 h-4" />
//                   Enroll User
//                 </>
//               )}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ImportUserTemplate;


// components/ImportUserTemplate.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { X, Smartphone, User, Fingerprint, Loader2, AlertCircle, Wifi, CheckCircle, XCircle } from 'lucide-react';
import {Get_Managers_User} from '../../../services/oprations/Users'

const ImportUserTemplate = ({ 
  isOpen, 
  onClose, 
  users, 
  devices, 
  onSubmit, 
  isEnrolling,
  errors,
  preselectedUser = null,
  socket = null,
  theme
}) => {
  const dispatch = useDispatch()
  const [selectedUserId, setSelectedUserId] = useState('');
  const [selectedDeviceId, setSelectedDeviceId] = useState('');
  const [selectedTemplateId, setSelectedTemplateId] = useState('');
  const [localErrors, setLocalErrors] = useState({});
  const [selectedUserTemplates, setSelectedUserTemplates] = useState([]);
  
  // Socket communication states
  const [socketStatus, setSocketStatus] = useState(null);
  const [socketMessage, setSocketMessage] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [receivedSuccess, setReceivedSuccess] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  
  // Use ref to track if component is mounted
  const isMounted = useRef(true);
  const timeoutRef = useRef(null);

  const isDark = theme === 'dark';

  // Theme-aware classes
  const bgModal = isDark ? 'bg-richblue-800' : 'bg-white';
  //const bgHeader = isDark ? 'bg-richblue-800' : 'bg-white';
  const bgSelect = isDark ? 'bg-richblue-900' : 'bg-gray-50';
  //const bgStatusBase = isDark ? 'bg-richblue-800' : 'bg-gray-100';
  
  const borderColor = isDark ? 'border-blue-700/50' : 'border-gray-300';
  const borderLight = isDark ? 'border-blue-700/50' : 'border-gray-200';
  const borderInput = isDark ? 'border-blue-700/50' : 'border-gray-300';
  const borderError = isDark ? 'border-red-500' : 'border-red-400';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  //const textSecondary = isDark ? 'text-gray-300' : 'text-gray-700';
  //const textMuted = isDark ? 'text-gray-400' : 'text-gray-500';
  //const textBlue = isDark ? 'text-blue-400' : 'text-blue-600';
  
  const bgStatusSuccess = isDark ? 'border-green-500/50 bg-green-900/20' : 'border-green-400 bg-green-50';
  const bgStatusError = isDark ? 'border-red-500/50 bg-red-900/20' : 'border-red-400 bg-red-50';
  const bgStatusProcessing = isDark ? 'border-blue-500/50 bg-blue-900/20' : 'border-blue-400 bg-blue-50';
  const bgStatusDefault = isDark ? 'border-blue-700/50 bg-richblue-800' : 'border-gray-300 bg-gray-50';
  
  const bgTemplateList = isDark ? 'bg-blue-900/20 border-blue-700/50' : 'bg-blue-50 border-blue-300';
  const bgTemplateItem = isDark ? 'bg-richblue-900/50 border-blue-700/30 hover:bg-blue-500/10' : 'bg-gray-50 border-gray-300 hover:bg-blue-50';
  const bgTemplateSelected = isDark ? 'bg-blue-500/30 border-blue-400' : 'bg-blue-200 border-blue-500';
  const bgNoTemplates = isDark ? 'bg-yellow-900/20 border-yellow-700/50' : 'bg-yellow-50 border-yellow-300';
  
  const buttonCancel = isDark 
    ? 'bg-richblue-700 hover:bg-richblue-600 text-gray-300' 
    : 'bg-gray-200 hover:bg-gray-300 text-gray-700';
  const buttonSubmit = isDark
    ? 'bg-blue-600 hover:bg-blue-500'
    : 'bg-blue-500 hover:bg-blue-600';
  const buttonClose = isDark ? 'hover:bg-richblue-700' : 'hover:bg-gray-100';
  
  //const textError = isDark ? 'text-red-400' : 'text-red-600';
  const textYellow = isDark ? 'text-yellow-300' : 'text-yellow-700';

  // Set isMounted on mount/unmount
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  // Reset form when modal opens
  useEffect(() => {
    if (isOpen) {
      if (preselectedUser) {
        setSelectedUserId(preselectedUser._id);
      } else {
        setSelectedUserId('');
      }
      setSelectedDeviceId('');
      setSelectedTemplateId('');
      setLocalErrors({});
      setSelectedUserTemplates([]);
      setSocketStatus(null);
      setSocketMessage('');
      setIsProcessing(false);
      setReceivedSuccess(false);
      setHasSubmitted(false);
    }
  }, [isOpen, preselectedUser]);

  // Socket event listeners - SAFE VERSION with error handling
  useEffect(() => {
    if (!socket || !isOpen || !socket.on) return;

    const handleImportProcess = (data) => {
      if (!isMounted.current) return;
      
      try {
        const message = data && typeof data === 'object' ? data.message : null;
        const errorDetails = data && typeof data === 'object' ? data.errorDetails : null;
        
        console.log("Socket IMPORT_PROCESS received:", message);
        
        if (message === 'SUCCESS') {
          setSocketStatus('success');
          setSocketMessage('User successfully enrolled to device!');
          setIsProcessing(false);
          setReceivedSuccess(true);
          dispatch(Get_Managers_User())
          
          timeoutRef.current = setTimeout(() => {
            if (isMounted.current) {
              onClose();
            }
          }, 2000);
        } 
        else if (message === 'FAILED' || message === 'error') {
          setSocketStatus('error');
          setSocketMessage(errorDetails || 'Enrollment failed. Please try again.');
          setIsProcessing(false);
          setHasSubmitted(false);
        }
        else if (message) {
          setSocketMessage(message);
          if (typeof message === 'string' && 
              (message.includes('processing') || message.includes('started'))) {
            setSocketStatus('processing');
            setIsProcessing(true);
          }
        }
      } catch (err) {
        console.error('Error handling socket message:', err);
        if (isMounted.current) {
          setSocketStatus('error');
          setSocketMessage('An error occurred. Please try again.');
          setIsProcessing(false);
          setHasSubmitted(false);
        }
      }
    };

    try {
      socket.on('IMPORT_PROCESS', handleImportProcess);
    } catch (err) {
      console.error('Failed to attach socket listener:', err);
    }

    return () => {
      try {
        if (socket && socket.off) {
          socket.off('IMPORT_PROCESS', handleImportProcess);
        }
      } catch (err) {
        console.error('Failed to remove socket listener:', err);
      }
    };
  }, [socket, isOpen, onClose, dispatch]);

  // Load user templates when user is selected
  useEffect(() => {
    if (selectedUserId && users && users.length) {
      try {
        const selectedUser = users.find(u => u._id === selectedUserId);
        const templates = selectedUser?.Templates || [];
        setSelectedUserTemplates(templates);
        
        if (templates.length > 0 && !selectedTemplateId && isMounted.current) {
          setSelectedTemplateId(templates[0]._id);
        }
      } catch (err) {
        console.error('Error loading user templates:', err);
        setSelectedUserTemplates([]);
      }
    } else {
      setSelectedUserTemplates([]);
    }
  }, [selectedUserId, users, selectedTemplateId]);

  const validateForm = () => {
    const newErrors = {};
    if (!selectedUserId) newErrors.user = 'Please select a user';
    if (!selectedDeviceId) newErrors.device = 'Please select a device';
    if (!selectedTemplateId?.trim()) newErrors.template = 'Please select a fingerprint template';
    
    setLocalErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    if (hasSubmitted || isProcessing || !isMounted.current) {
      console.log("Submission already in progress or component unmounted, ignoring...");
      return;
    }
    
    if (validateForm()) {
      try {
        const selectedUser = users.find(u => u._id === selectedUserId);
        const selectedDevice = devices.find(d => d._id === selectedDeviceId);
        const selectedTemplate = selectedUserTemplates.find(t => t._id === selectedTemplateId);
        
        setSocketStatus('processing');
        setSocketMessage('Sending enrollment request...');
        setReceivedSuccess(false);
        setIsProcessing(true);
        setHasSubmitted(true);
        
        onSubmit({
          userId: selectedUserId,
          deviceId: selectedDeviceId,
          templateId: selectedTemplateId,
          templateType: selectedTemplate?.Type || '',
          userEmail: selectedUser?.user_email || '',
          userName: selectedUser?.user_name || '',
          deviceName: selectedDevice?.device_name || '',
        });
      } catch (err) {
        console.error('Error in handleSubmit:', err);
        setSocketStatus('error');
        setSocketMessage('Failed to submit enrollment request');
        setIsProcessing(false);
        setHasSubmitted(false);
      }
    }
  };

  const getStatusIcon = () => {
    try {
      switch(socketStatus) {
        case 'success':
          return <CheckCircle className="w-5 h-5 text-green-400" />;
        case 'error':
          return <XCircle className="w-5 h-5 text-red-400" />;
        case 'processing':
          return <Loader2 className="w-5 h-5 text-blue-400 animate-spin" />;
        default:
          return <Wifi className="w-5 h-5 text-blue-400" />;
      }
    } catch {
      return <Wifi className="w-5 h-5 text-blue-400" />;
    }
  };

  const getStatusColor = () => {
    switch(socketStatus) {
      case 'success':
        return bgStatusSuccess;
      case 'error':
        return bgStatusError;
      case 'processing':
        return bgStatusProcessing;
      default:
        return bgStatusDefault;
    }
  };

  if (!isOpen) return null;

  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${isDark ? 'bg-black/70' : 'bg-gray-500/40'} backdrop-blur-sm`}>
      <div className={`relative w-full max-w-md ${bgModal} rounded-xl border ${borderColor} shadow-xl transition-colors duration-300`}>
        {/* Header */}
        <div className={`flex items-center justify-between p-4 border-b ${borderLight}`}>
          <div className="flex items-center gap-2">
            <div className="p-1.5 rounded-lg bg-blue-500/20">
              <Fingerprint className="w-4 h-4 text-blue-400" />
            </div>
            <h2 className={`text-lg font-semibold ${textPrimary}`}>
              Enroll {preselectedUser ? preselectedUser.user_name : 'User'} to Device
            </h2>
          </div>
          <button
            onClick={() => {
              if (timeoutRef.current) clearTimeout(timeoutRef.current);
              onClose();
            }}
            className={`p-1 rounded-lg ${buttonClose} transition-colors`}
            disabled={isEnrolling || (isProcessing && !receivedSuccess)}
          >
            <X className={`w-5 h-5 ${isDark ? 'text-gray-400' : 'text-gray-500'}`} />
          </button>
        </div>

        {/* Socket Status Display */}
        {socket && socketStatus && (
          <div className={`mx-4 mt-4 p-3 rounded-lg border ${getStatusColor()} transition-all duration-300`}>
            <div className="flex items-center gap-3">
              {getStatusIcon()}
              <div className="flex-1">
                <p className={`text-sm font-medium ${textPrimary}`}>
                  {socketStatus === 'processing' ? 'Processing Enrollment' : 
                   socketStatus === 'success' ? 'Enrollment Successful' :
                   socketStatus === 'error' ? 'Enrollment Failed' :
                   'Status'}
                </p>
                {socketMessage && (
                  <p className={`text-xs mt-1 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>{socketMessage}</p>
                )}
                {socketStatus === 'processing' && (
                  <div className="mt-2">
                    <div className={`w-full ${isDark ? 'bg-richblue-700' : 'bg-gray-300'} rounded-full h-1.5 overflow-hidden`}>
                      <div 
                        className="bg-blue-500 h-1.5 rounded-full animate-pulse"
                        style={{ width: '100%' }}
                      />
                    </div>
                    <p className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'} mt-1`}>Waiting for device response...</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit} className="p-4 space-y-4">
          {/* User Selection */}
          <div>
            <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
              Select User <span className="text-red-400">*</span>
            </label>
            <div className="relative">
              <User className={`absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 ${isDark ? 'text-gray-400' : 'text-gray-500'}`} />
              <select
                value={selectedUserId}
                onChange={(e) => setSelectedUserId(e.target.value)}
                className={`w-full pl-9 pr-3 py-2 ${bgSelect} border rounded-lg ${textPrimary} focus:outline-none focus:ring-2 focus:ring-blue-500/50 ${
                  localErrors.user ? borderError : borderInput
                } ${preselectedUser ? 'opacity-60 cursor-not-allowed' : ''} transition-colors duration-300`}
                disabled={isEnrolling || isProcessing || !!preselectedUser}
              >
                <option value="">Select a user...</option>
                {users.map((user) => (
                  <option key={user._id} value={user._id} className={isDark ? 'bg-richblue-900' : 'bg-white'}>
                    {user.user_name} ({user.user_email || 'No email'}) - {user.Templates?.length || 0} template(s)
                  </option>
                ))}
              </select>
            </div>
            {localErrors.user && (
              <p className="mt-1 text-xs text-red-400">{localErrors.user}</p>
            )}
          </div>

          {/* Device Selection */}
          <div>
            <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
              Select Device <span className="text-red-400">*</span>
            </label>
            <div className="relative">
              <Smartphone className={`absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 ${isDark ? 'text-gray-400' : 'text-gray-500'}`} />
              <select
                value={selectedDeviceId}
                onChange={(e) => setSelectedDeviceId(e.target.value)}
                className={`w-full pl-9 pr-3 py-2 ${bgSelect} border rounded-lg ${textPrimary} focus:outline-none focus:ring-2 focus:ring-blue-500/50 ${
                  localErrors.device ? borderError : borderInput
                } transition-colors duration-300`}
                disabled={isEnrolling || isProcessing}
              >
                <option value="">Select a device...</option>
                {devices.map((device) => (
                  <option key={device._id} value={device._id} className={isDark ? 'bg-richblue-900' : 'bg-white'}>
                    {device.device_name} ({device.status || 'Unknown'})
                  </option>
                ))}
              </select>
            </div>
            {localErrors.device && (
              <p className="mt-1 text-xs text-red-400">{localErrors.device}</p>
            )}
          </div>

          {/* Template Selection */}
          <div>
            <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
              Select Fingerprint Template <span className="text-red-400">*</span>
            </label>
            
            {selectedUserTemplates.length > 0 ? (
              <div className={`mb-2 p-2 rounded-lg ${bgTemplateList} border transition-colors duration-300`}>
                <div className="flex items-center gap-2 mb-2">
                  <AlertCircle className="w-3 h-3 text-blue-400" />
                  <span className={`text-xs ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>Available templates:</span>
                </div>
                <div className="space-y-2">
                  {selectedUserTemplates.map((template) => (
                    <label 
                      key={template._id}
                      className={`flex items-center gap-2 p-2 rounded-lg cursor-pointer transition-colors ${
                        selectedTemplateId === template._id 
                          ? bgTemplateSelected
                          : bgTemplateItem
                      }`}
                    >
                      <input
                        type="radio"
                        name="template"
                        value={template._id}
                        checked={selectedTemplateId === template._id}
                        onChange={() => setSelectedTemplateId(template._id)}
                        className="w-4 h-4 text-blue-500"
                        disabled={isProcessing}
                      />
                      <div className="flex-1">
                        <div className="flex items-center justify-between">
                          <span className={`text-sm font-medium ${textPrimary}`}>{template.Type}</span>
                          <span className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'} font-mono`}>
                            ID: {template._id?.slice(-6)}
                          </span>
                        </div>
                      </div>
                      <Fingerprint className="w-4 h-4 text-blue-400" />
                    </label>
                  ))}
                </div>
              </div>
            ) : (
              selectedUserId && (
                <div className={`p-3 rounded-lg border ${bgNoTemplates} transition-colors duration-300`}>
                  <p className={`text-xs ${textYellow}`}>
                    ⚠️ This user has no fingerprint templates registered.
                  </p>
                </div>
              )
            )}
            
            {localErrors.template && (
              <p className="mt-1 text-xs text-red-400">{localErrors.template}</p>
            )}
          </div>

          {/* Buttons */}
          <div className="flex gap-3 pt-2">
            <button
              type="button"
              onClick={() => {
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
                onClose();
              }}
              className={`flex-1 px-4 py-2 text-sm font-medium transition-colors rounded-lg ${buttonCancel} disabled:opacity-50`}
              disabled={isEnrolling || (isProcessing && !receivedSuccess)}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isEnrolling || isProcessing || (selectedUserId && selectedUserTemplates.length === 0) || hasSubmitted}
              className={`flex-1 flex items-center justify-center gap-2 px-4 py-2 text-sm font-semibold text-white transition-colors rounded-lg ${buttonSubmit} disabled:opacity-50 disabled:cursor-not-allowed`}
            >
              {isEnrolling || isProcessing ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" />
                  {socketStatus === 'processing' ? 'Processing...' : 'Enrolling...'}
                </>
              ) : (
                <>
                  <Fingerprint className="w-4 h-4" />
                  Enroll User
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ImportUserTemplate;
